import { InjectableClass } from '@fino/lib-injection';

export class UploadSummaryController extends InjectableClass {
  constructor(controllerService, uploadSummaryFields, $filter, $timeout) {
    'ngInject';
    super({ controllerService, uploadSummaryFields, $filter, $timeout });
  }

  get files() {
    return this.internalFiles;
  }

  getErrorMessage(file) {
    return 'ui.fileUpload.error.' + (file.error.code || file.error.status);
  }

  set files(files) {
    this.internalFiles =
      files &&
      files.length &&
      files.map((file) => {
        const onRenderProgress = (progress) => {
          // As soon as the progress reaches 100% and the file has no error attached
          // the file has been uploaded successfully.
          if (progress === 100 && !file.error) {
            this.$timeout(() => {
              // Untag all uploaded files
              this.untagAsUploaded();
              file.uploaded = true;
            });
          }
        };
        return angular.extend(file, { onRenderProgress });
      });
  }

  untagAsUploaded() {
    this.files.forEach((f) => {
      f.uploaded = false;
      f.progress = 0;
    });
  }

  removeChoice(index) {
    this.files.splice(index, 1);
  }
}
